import { __assign, __rest } from "tslib";
import React from 'react';
import s from './app-market-link.scss';
import { useConfigContext } from '../../config-context';
export var FakeLink = function (_a) {
    var to = _a.to, className = _a.className, children = _a.children, onClick = _a.onClick;
    return (React.createElement("a", { href: to, className: className, onClick: function (e) {
            e.preventDefault();
            onClick && onClick(e);
        } }, children));
};
export var AppMarketLink = function (_a) {
    var to = _a.to, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, restOfTheProps = __rest(_a, ["to", "className", "children", "onClick"]);
    var baseUrl = useConfigContext().baseUrl;
    var _to = to
        ? "" + baseUrl + to
        : baseUrl && baseUrl.substr(0, baseUrl.length - 1);
    return (React.createElement(FakeLink, __assign({ className: s.link + " " + className, to: _to, onClick: onClick }, restOfTheProps), children));
};
//# sourceMappingURL=app-market-link.js.map